import { Alert } from "react-bootstrap";

function CautionMsg(props: any) {
  return (
    <>
      {props.caution_msg && (
        <div className="item">
          <Alert
            variant={"warning"}
            style={{ padding: 5, fontSize: 14, margin: 0 }}
          >
            <p className="text-wrap">{props.caution_msg}</p>
          </Alert>
        </div>
      )}
    </>
  );
};

export default CautionMsg;